import client from './client';

export const conversationsApi = {
  async listAll(params = {}) {
    const { data } = await client.get('/api/conversations', { params });
    return data;
  },

  async listFilters() {
    const { data } = await client.get('/api/conversations/filters');
    return data;
  },

  async list(projectKey, params = {}) {
    const { data } = await client.get(`/api/projects/${projectKey}/conversations`, { params });
    return data;
  },

  async get(projectKey, id) {
    const { data } = await client.get(`/api/projects/${projectKey}/conversations/${id}`);
    return data;
  },

  async getContent(projectKey, id) {
    const { data } = await client.get(`/api/projects/${projectKey}/conversations/${id}/content`);
    return data;
  },

  async upload(projectKey, file) {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await client.post(`/api/projects/${projectKey}/conversations`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  getBackupDownloadUrl(projectKey, id, s3Key) {
    const base = `/api/projects/${projectKey}/conversations/${id}/backup-download`;
    return s3Key ? `${base}?key=${encodeURIComponent(s3Key)}` : base;
  },

  async delete(projectKey, id) {
    const { data } = await client.delete(`/api/projects/${projectKey}/conversations/${id}`);
    return data;
  },

  async getLinks(projectKey, id) {
    const { data } = await client.get(`/api/projects/${projectKey}/conversations/${id}/links`);
    return data;
  },

  async createLink(projectKey, id, body) {
    const { data } = await client.post(
      `/api/projects/${projectKey}/conversations/${id}/links`,
      body
    );
    return data;
  },

  async deleteLink(projectKey, id, linkId) {
    const { data } = await client.delete(
      `/api/projects/${projectKey}/conversations/${id}/links/${linkId}`
    );
    return data;
  },

  async listNotes(projectKey, id) {
    const { data } = await client.get(`/api/projects/${projectKey}/conversations/${id}/notes`);
    return data;
  },

  async addNote(projectKey, id, body) {
    const { data } = await client.post(`/api/projects/${projectKey}/conversations/${id}/notes`, {
      body,
    });
    return data;
  },

  async deleteNote(projectKey, id, noteId) {
    const { data } = await client.delete(
      `/api/projects/${projectKey}/conversations/${id}/notes/${noteId}`
    );
    return data;
  },

  // Customer-scoped methods
  async listForCustomer(customerId, params = {}) {
    const { data } = await client.get(`/api/customers/${customerId}/conversations`, { params });
    return data;
  },

  async getForCustomer(customerId, id) {
    const { data } = await client.get(`/api/customers/${customerId}/conversations/${id}`);
    return data;
  },

  async getContentForCustomer(customerId, id) {
    const { data } = await client.get(`/api/customers/${customerId}/conversations/${id}/content`);
    return data;
  },

  getBackupDownloadUrlForCustomer(customerId, id, s3Key) {
    const base = `/api/customers/${customerId}/conversations/${id}/backup-download`;
    return s3Key ? `${base}?key=${encodeURIComponent(s3Key)}` : base;
  },

  async deleteForCustomer(customerId, id) {
    const { data } = await client.delete(`/api/customers/${customerId}/conversations/${id}`);
    return data;
  },

  async getLinksForCustomer(customerId, id) {
    const { data } = await client.get(`/api/customers/${customerId}/conversations/${id}/links`);
    return data;
  },

  async createLinkForCustomer(customerId, id, body) {
    const { data } = await client.post(
      `/api/customers/${customerId}/conversations/${id}/links`,
      body
    );
    return data;
  },

  async deleteLinkForCustomer(customerId, id, linkId) {
    const { data } = await client.delete(
      `/api/customers/${customerId}/conversations/${id}/links/${linkId}`
    );
    return data;
  },

  async listNotesForCustomer(customerId, id) {
    const { data } = await client.get(`/api/customers/${customerId}/conversations/${id}/notes`);
    return data;
  },

  async addNoteForCustomer(customerId, id, body) {
    const { data } = await client.post(`/api/customers/${customerId}/conversations/${id}/notes`, {
      body,
    });
    return data;
  },

  async deleteNoteForCustomer(customerId, id, noteId) {
    const { data } = await client.delete(
      `/api/customers/${customerId}/conversations/${id}/notes/${noteId}`
    );
    return data;
  },
};
